import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import LazyLoad from "react-lazyload";
import BlogImage1 from "../../assets/img/communities/community-center-img.jpg";

import * as apiUrl from "../../apiUrl";

function CommunityInnerpageDescription({ title, descriptions, sectionImage }) {


  const parsedDescriptions = descriptions ? JSON.parse(descriptions) : [];

  return (
    <section className="latest-blog-sec">
      <Container fluid>
        <Row className="flex-center">
          <Col md={10} className="padding-zero">
            <div className="latest-blog-content-div" data-aos="fade-up">
              <h2 className="common-head greyColor text-center">{title}</h2>
              <Col md={12} className="padding-zero">
                <img
                  src={`${apiUrl.apiUrl}/${sectionImage}`}
                  className="img-fluid mb-4"
                  alt="Properties"
                />
              </Col>
              {parsedDescriptions.map((description, index) => (
                <p className="common-para" key={index}>
                  {description}
                </p>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default CommunityInnerpageDescription;
